import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Menu, MenuCreate, MenuFilter } from '../data/menu';

export function createMenuService(client: AxiosInstance) {
  return createCrudService<Menu, MenuCreate, MenuFilter>(client, "/restaurant/Menu", "menuId");
}

export type MenuService = CrudService<Menu, MenuCreate, MenuFilter>;
